import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import { FaArrowLeft } from "react-icons/fa";
import { Button, FileInput } from "../../../components/ui";
import apiService from "../../../services/apiService";
import Loader from "../../../components/ui/Loader";
import fileManagerService from "../../../services/fileManagerService";
import {
  Dialog,
  Progress,
  Typography,
  DialogBody,
  IconButton,
  DialogHeader,
  DialogFooter,
  Stepper,
  Step,
  Timeline,
  TimelineBody,
  TimelineConnector,
  TimelineHeader,
  TimelineIcon,
  TimelineItem,
  Spinner,
} from "@material-tailwind/react";
import { XMarkIcon } from "@heroicons/react/24/outline";
import {
  InformationCircleIcon,
  BellIcon,
  ArchiveBoxIcon,
  CurrencyDollarIcon,
  CheckBadgeIcon,
} from "@heroicons/react/24/solid";
import { useToast } from "../../../context/ToastContext";

const breadcrumb = (
  <span>
    Home &nbsp;/&nbsp;{" "}
    <a href="/web-pages" className="text-blue-600">
      Webpages
    </a>{" "}
    &nbsp;/&nbsp; <span className="text-gray-700">Add Webpage</span>
  </span>
);

const UploadSolution = () => {
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  //   const [qName,setQName]=useState('')
  //   const [file,setFile]=useState(null)
  //const [qSetId,setqSetId]=useState()
  //   const [message,setMessage]=useState()
  //   const [progress,setProgress]=useState()
  //   const [progressMessage,setProgressMessage]=useState()
  const [jobId, setJobId] = useState();
  const [uploadComplete, setUploadComplete] = useState(false);
  const [activeStep, setActiveStep] = useState(1);

  const { showSuccess, showError, showInfo, showWarning } = useToast();
  const handleOpen = () => {
    setOpen(!open);
    setUploadComplete(false);
  };
  const qSetId = useParams().id;
  console.log(qSetId);

  async function handleSubmitCustom(data) {
    //e.preventDefault();
    setLoading(true);
    const formData = new FormData();
    const file = data.file[0];
    if (!file) return window.alert("No file attached");
    else formData.append("pdfFile", file);
    formData.append("qSet", qSetId);

    try {
      let rp;
      rp = await fileManagerService.uploadFileLocalTestSolution(
        formData,
        `/test/upload/pdf/solution/${qSetId}`,
      );
      setLoading(false);
      showSuccess("File Received! Check status on Dashboard");
      // setJobId(rp.jobId)
      // setOpen(true)
      console.log("Success", rp);
    } catch (err) {
      setLoading(false);
      console.log(err);
      showError("Upload Failed");
    }
  }

  // SSE Code
  //   useEffect(() => {
  //     const eventSource = new EventSource(
  //       `http://localhost:1334/api/progress/${jobId}`,
  //     );

  //     eventSource.onmessage = (event) => {
  //       const data = JSON.parse(event.data);
  //       //setProgress(data.progress);
  //       //setProgressMessage(data.message);
  //       setActiveStep(data.activeStep);

  //       if (data.activeStep === -1) {
  //         console.log("Failed");
  //         eventSource.close();
  //         setOpen(false);
  //         window.alert("Upload Failed");
  //       } else if (data.activeStep >= 3) {
  //         setUploadComplete(true);
  //         //setOpen(false)
  //         eventSource.close();
  //       }
  //     };

  //     eventSource.onerror = (err) => {
  //       console.error("SSE error:", err);
  //       setOpen(false);
  //       window.alert("Upload Failed");
  //       eventSource.close();
  //     };

  //     return () => {
  //       eventSource.close();
  //     };
  //   }, [jobId]);

  //   async function handleSubmitCustom(data) {
  //     setLoading(true);

  //     const formData = new FormData();
  //     const file = data.file?.[0];

  //     if (!file) {
  //       setLoading(false);
  //       return window.alert("No file attached");
  //     }

  //     if (!qSetId) {
  //       setLoading(false);
  //       return showError("QSet Id not found in URL");
  //     }

  //     formData.append("mdFile", file);

  //     try {
  //       const rp = await fileManagerService.uploadFileLocalTestSolution(
  //         formData,
  //         qSetId,
  //       );

  //       setLoading(false);
  //       showSuccess("File Received! Check status on Dashboard");
  //       console.log("Success", rp);
  //     } catch (err) {
  //       setLoading(false);
  //       console.log(err);
  //       showError("Upload Failed");
  //     }
  //   }

  return (
    <div className="p-4">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold">Upload Solutions</h1>
        <Button
          onClick={() => navigate("/tools/qSet")}
          variant="light"
          size="sm"
          icon={FaArrowLeft}
        >
          Back to List
        </Button>
      </div>

      <div className="flex items-center text-sm mb-6">
        <span className="text-gray-500">Home</span>
        <span className="mx-2">/</span>
        <span onClick={() => navigate("/tools/qSet")} className="text-gray-500">
          QSet
        </span>
        <span className="mx-2">/</span>
        <span className="text-blue-600">Solution</span>
      </div>

      <div className="bg-white rounded-lg shadow-md overflow-hidden mb-6">
        <div className="p-2">
          <div>
            <form onSubmit={handleSubmit((data) => handleSubmitCustom(data))}>
              <div className="flex flex-col justify-around">
                {/* <div className='p-3'>
                            <label className='block text-gray-700 mb-2'>Question Set Id : {qSetId}</label>
                        </div> */}

                <div className="p-3">
                  <label className="block text-gray-700 mb-2">
                    Select Markdown File<span className="text-red-500">*</span>
                  </label>
                  <input
                    type="file"
                    className="m-2"
                    accept=".pdf"
                    {...register("file", {
                      required: "File is required",
                    })}
                  />
                  {errors.file && (
                    <p className="text-red-500 text-sm">
                      {errors.file.message}
                    </p>
                  )}
                </div>

                <div className="p-3">
                  <button
                    type="submit"
                    className="bg-green-500 font-thin text-white p-2 rounded hover:bg-green-600 m-2"
                  >
                    Upload
                  </button>
                  {loading && <Loader />}
                </div>
              </div>
            </form>
          </div>

          {/* SSE Timeline */}
          {/* <Dialog open={open} handler={handleOpen} className="p-4">
                <DialogHeader className="relative m-0 block">
                    {uploadComplete?(
                        <Typography variant="h4" color="blue-gray">
                            Upload Complete!!
                        </Typography>
                    ):(
                        <>
                    <Typography variant="h4" color="blue-gray">
                        Upload Progress
                    </Typography>
                    <Typography className="mt-1 font-normal text-gray-600">
                        Please wait while we process your request. You can track the upload
                        progress below.
                    </Typography>
                    </>
                    )}
                    <IconButton
                        size="sm"
                        variant="text"
                        className="!absolute right-3.5 top-3.5"
                        onClick={handleOpen}
                    >
                    <XMarkIcon className="h-4 w-4 stroke-2" />
                    </IconButton>
                </DialogHeader>
                
                <DialogBody>                    
                    <Timeline>
                        <TimelineItem className="h-20">
                            <TimelineConnector className="!w-[78px]" />
                            <TimelineHeader className="relative rounded-xl border border-blue-gray-50 bg-white py-3 pl-4 pr-8 shadow-lg shadow-blue-gray-900/5">
                                <TimelineIcon className="p-3" variant="ghost">
                                    {activeStep===1?<Spinner/>:<CheckBadgeIcon className='h-5 w-5'/>}
                                </TimelineIcon>
                                <div className="flex flex-col gap-1">
                                    <Typography variant="h6" color="blue-gray">
                                        {activeStep===1?'Initiating':'Initiated'}
                                    </Typography>
                                </div>
                            </TimelineHeader>
                        </TimelineItem>
                        {activeStep<1?(<></>):(
                        <TimelineItem className="h-20">
                            <TimelineConnector className="!w-[78px]" />
                            <TimelineHeader className="relative rounded-xl border border-blue-gray-50 bg-white py-3 pl-4 pr-8 shadow-lg shadow-blue-gray-900/5">
                                <TimelineIcon className="p-3" variant="ghost">
                                    {activeStep===1?<Spinner/>:<CheckBadgeIcon className='h-5 w-5'/>}
                                </TimelineIcon>
                                <div className="flex flex-col gap-1">
                                    <Typography variant="h6" color="blue-gray">
                                        {activeStep===1?'Converting pdf converted to Text':'Pdf converted to Text'}
                                    </Typography>
                                </div>
                            </TimelineHeader>
                        </TimelineItem>
                        )}
                        {activeStep<2?(<></>):(
                        <TimelineItem className="h-20">
                            <TimelineConnector className="!w-[78px]" />
                            <TimelineHeader className="relative rounded-xl border border-blue-gray-50 bg-white py-3 pl-4 pr-8 shadow-lg shadow-blue-gray-900/5">
                                <TimelineIcon className="p-3" variant="ghost">
                                    {activeStep===2?<Spinner/>:<CheckBadgeIcon className='h-5 w-5'/>}
                                </TimelineIcon>
                                <div className="flex flex-col gap-1">
                                    <Typography variant="h6" color="blue-gray">
                                        {activeStep===2?'Parsing Text':'All Text is parsed'}
                                    </Typography>
                                </div>
                            </TimelineHeader>
                        </TimelineItem>
                        )}
                        {activeStep<3?(<></>):(
                        <TimelineItem className="h-20">
                            <TimelineConnector className="!w-[78px]" />
                            <TimelineHeader className="relative rounded-xl border border-blue-gray-50 bg-white py-3 pl-4 pr-8 shadow-lg shadow-blue-gray-900/5">
                                <TimelineIcon className="p-3" variant="ghost">
                                    {activeStep===3?<Spinner/>:<CheckBadgeIcon className='h-5 w-5'/>}
                                </TimelineIcon>
                                <div className="flex flex-col gap-1">
                                    <Typography variant="h6" color="blue-gray">
                                        {activeStep===3?'Winding Things':'Conversion Complete'}
                                    </Typography>
                                </div>
                            </TimelineHeader>
                        </TimelineItem>
                        )}
                        
                    </Timeline>
                </DialogBody>
                
                
                <DialogFooter className="flex flex-wrap justify-around ">
                    {activeStep!==6?(<></>):(
                    <Button onClick={handleOpen} className="w-full lg:max-w-fit">
                        Ok
                    </Button>)}
                </DialogFooter>
                
            </Dialog> */}
        </div>
      </div>

      <div className="mt-6 bg-gray-50 border rounded-lg p-4">
        <h3 className="font-semibold mb-2">Instructions:</h3>
        <ul className="list-disc pl-5">
          <li>
            Fields marked with <span className="text-red-500">*</span> are
            mandatory.
          </li>
        </ul>
      </div>
    </div>
  );
};

export default UploadSolution;
